import React, { useState, useEffect } from 'react';

// O componente agora recebe text, speed, e todas as outras props (id, className)
const TypingEffect = ({ text, speed, ...rest }) => {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        if (!text) {
            setDisplayedText(""); 
            return;
        }

        // Variável local para rastrear o índice
        let currentTextIndex = 0; 

        // Função para iniciar a digitação
        const startTyping = () => {
             const typingInterval = setInterval(() => {
                // Se ainda houver caracteres para digitar
                if (currentTextIndex < text.length) {
                    const nextChar = text[currentTextIndex];
                    
                    // Adiciona o caractere DE FORMA SEGURA e FUNCIONAL
                    setDisplayedText(prevText => prevText + nextChar);
                    
                    currentTextIndex++; // Incrementa o índice
                } else {
                    // Limpa o intervalo quando a digitação terminar
                    clearInterval(typingInterval);
                }
            }, speed);
            return typingInterval;
        };

        const intervalId = startTyping();

        // Limpa o intervalo ao desmontar ou se 'text'/'speed' mudarem
        return () => clearInterval(intervalId);

    // O useEffect re-executa se o texto ou velocidade mudarem
    }, [text, speed]); 

    // Função para renderizar o texto com <br> para quebras de linha
    const renderText = () => {
        // Divide o texto que JÁ FOI DIGITADO em linhas
        // Isso resolve o problema de renderização de '\n'
        return displayedText.split('\n').map((line, index, arr) => (
            <React.Fragment key={index}>
                {line}
                {/* Adiciona <br> se não for a última linha */}
                {index < arr.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <span {...rest}> 
            {renderText()}
        </span>
    );
};

export default TypingEffect;